
// import store from '@/store'

export function trackEvent (category, action, label = '') {
  pushToDataLayer({
    event: 'GTM-GAevent',
    eventCategory: category,
    eventAction: action,
    eventLabel: label
  })
}

function pushToDataLayer (obj) {
  if (window.dataLayer != null && window.dataLayer instanceof Array) {
    window.dataLayer.push(obj)
  }
}
